export default "__VITE_ASSET__MwUCt3gd__"